import { api } from "./connection/api";

const VERIFF_ENDPOINT_PREFIX = "veriff";

export const veriffApi = api.injectEndpoints({
    endpoints: builder => ({
        createSession: builder.mutation({
            query: () => {
                return {
                    url: `${VERIFF_ENDPOINT_PREFIX}/session`,
                    method: "POST",
                };
            },
        }),
        verificationStatus: builder.query({
            query: () => ({
                url: `${VERIFF_ENDPOINT_PREFIX}/verificationStatus`,
            }),
        }),
    }),
});

export const {
    useCreateSessionMutation,
    endpoints: { verificationStatus },
} = veriffApi;
